import React, { memo, useState } from 'react';
import classNames from 'classnames';
import FilterSelect from './FilterSelect';
import { activeFilterToggled, useFilterState } from '../store';
import { useDispatch, useSelector } from 'react-redux';
import { AppState, selectDeviceType } from 'core/redux/reducers';
import actions from 'core/redux/features/filters/actions';
import { selectSortFilterOptions } from 'core/redux/features/filters/reducers';
import MultiSelectBox from 'Components/Elements/Buttons/MultiSelectBox';

export const SortFilter = memo(function ({
  parentRef,
}: {
  parentRef: React.RefObject<HTMLElement>;
}) {
  const { filterDispatch } = useFilterState();
  const activeSort = useSelector(
    (state: AppState) => state.filters.activeFilters.sort,
  );

  const dispatch = useDispatch();
  const options = useSelector((state: AppState) =>
    selectSortFilterOptions(state.filters),
  );
  const deviceType = useSelector(selectDeviceType);

  const [openState, setOpenState] = useState(false);
  return (
    <div
      className={classNames('filter-head__filter')}
      onClick={e => {
        let openStateByDevice = !openState;
        if (deviceType === 'mobile') {
          if (openState) {
            //  sort in mobile is already open
            return;
          }
          e.preventDefault();
          openStateByDevice = true;
        }

        setOpenState(openStateByDevice);
        filterDispatch(activeFilterToggled('sort'));
      }}
      onMouseEnter={() => {
        if (deviceType !== 'mobile') {
          setOpenState(true);
        }
      }}
      onMouseLeave={() => {
        if (deviceType !== 'mobile') {
          setOpenState(false);
        }
      }}
    >
      {deviceType === 'mobile' ? (
        <div className="sort-filter-box filter-checkbox-column filters">
          <div className="eb-sort" />
          <MultiSelectBox
            hideLabel={true}
            multi={false}
            controlMobile={deviceType === 'mobile'}
            onClose={() => {
              setOpenState(false);
              // filterDispatch(activeFilterToggled('person'));
            }}
            onSave={item => {
              dispatch(actions.selectSort(item[0] as string));
            }}
            parentRef={parentRef}
            // headerName={trans('people')}
            name="Sort"
            options={options}
            id="filter-sort"
            selectedOptions={[activeSort]}
            isActiveDropdown={openState}
          />
        </div>
      ) : (
        <FilterSelect
          iosIviFix={true}
          activeOnHover={false}
          name="filter-sort"
          onSelect={(e, item) => {
            e.preventDefault();
            dispatch(actions.selectSort(item.id));
          }}
          isActive={openState}
          className="is-right"
          selected={{ id: activeSort }}
          options={options}
        >
          <div className="eb-sort" />
        </FilterSelect>
      )}
    </div>
  );
});
